<template>
  <main>
    <div class="grey">
      <div class="container">
        <div class="auth-links">
          <router-link tag="button" :to="{name: 'login'}" class="login">Вход</router-link>
          <router-link tag="button" :to="{name: 'reg'}">Присоединиться</router-link>
        </div>
        <div class="row" style="margin-top: 100px" v-if="isConstruction">
          <div class="frst col-8">
            <div class="text">Мы помогаем делать бизнес удобным</div>
            <img src="../assets/img/header/logo-green.png" alt="" style="width: 280px;" class="logo">
            <div class="text">Superbaer24 - новая платформа для баеров
              <!--Идёт финальное тестирование. <br> <b>Открытие 1 февраля 2021 года</b>--></div>
<!--            <h1>Сайт в разработке <br> Скоро открытие</h1>-->
            <div class="auth-links" style="justify-content: flex-start;">
              <router-link tag="button" :to="{name: 'reg'}">Зарегистрироваться</router-link>
            </div>
          </div>
<!--          <div class="col-6">-->
<!--            <img src="@/assets/img/under-construction.png" style="width: 400px; height: 400px">-->
<!--          </div>-->
        </div>
        <template v-else>
          <img src="../assets/img/logo.svg" alt="" class="logo">
          <div class="frst col-6"><h1>Первый удобный инструмент для успешной оптовой торговли в сегменте outdoor</h1></div>
        </template>
      </div>
    </div>
    <template v-if="!isConstruction">
      <div class="white">
        <div class="container">
          <div class="description">
            <div class="text">
              <div class="title">О нас</div>
              <div class="about">Superbaer24 — b2b платформа, которая собирает на одной интернет-площадке поставщиков и закупщиков товаров для туризма, охоты, рыбалки и отдыха на природе со всей России. </div>
              <div class="bottom">Зарегистрируйтесь сейчас, чтобы найти и выбрать новых контрагентов, быстро и эффективно взаимодействовать с существующими, оформить или получить заказ на закупку. </div>
            </div>
            <div class="image col-6  ">
            </div>
          </div>
        </div>
      </div>
      <div class="grey">
        <div class="container">
          <div class="advantages">
            <div class="rad center">
              <h2>Преимущества для</h2>
              <div class="radio">
                <div
                    class="radio-item"
                    v-for="(item) in tabs"
                    :class="{active: role == item.role}"
                    :key="item.role"
                    @click="role = item.role"
                >
                  {{item.title}}
                </div>

              </div>
            </div>
            <transition-group name="list-complete">
              <div
                  v-for="(item, i) in getAdvantages"
                  :key="`${role}_item${i}`"
                  :class="`crd crd_${i}`"
                  :style="{transitionDelay: `${(i+1)*90}ms`}"
              >
                <div class="num">{{ i+1 }}</div>
                <div class="title">{{item.title}}</div>
                <div class="name">{{item.name}}</div>
                <div class="text">{{item.text}}</div>
              </div>
            </transition-group>

          </div>
        </div>
      </div>
      <div class="white">
        <div class="container">
          <div class="reg">
            <h2>Сейчас на платформе зарегистрировано</h2>
            <div class="map"></div>
            <div class="numbers">
              <div class="item"
                   v-for="(item, idx) in nums"
                   :key="idx">
                <div class="num">{{item.num}}</div>
                <div class="name">{{item.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mask">
        <div class="bg">
          <div class="container">
            <div class="wrp">
              <h2 class="col-4" style="color: #FFFFFF">Для кого развиваем Superbaer24</h2>
              <div class="blr col-8">
                <div class="col-4">
                  <div class="blur">
                    <div class="title">Производители</div>
                    <div class="text">Если вы сами производите outdoor товары и ищите новые каналы сбыта, то у нас вы быстро найдете новых покупателей
                    </div>
                  </div>
                  <div class="blur">
                    <div class="title">Дистрибьюторы </div>
                    <div class="text">Неважно, занимаетесь ли вы поставкой зарубежных или отечественных товаров, у нас вы получите возможность расширить географию сбыта
                    </div>
                  </div>
                </div>
                <div class="col-4 blur">
                  <div class="title">Оффлайн и интернет-магазины</div>
                  <div class="text">Когда вы занимаетесь розничными продажами часто возникает потребность адаптировать ассортимент товаров под текущую ситуацию, а наша платформа предоставит вам возможность быстро находить нужное и сотрудничать с новыми поставщиками. Вы даже сможете сами зарегистрироваться как поставщик, чтобы продать ненужные остатки товаров</div>
                </div>
                <div class="col-4 blur">
                  <div class="title">Компании сегмента HORECA</div>
                  <div class="text">Если ваша компания относится к сфере услуг и вы занимаетесь организацией мероприятий и отдыха на природе, владеете рестораном с открытой верандой или ваша компания поставляет им оборудование и инвентарь — вы сможете купить подходящие товары outdoor у нас на платформе напрямую от производителей и дистрибуторов по выгодным условиям
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grey">
        <div class="container">
          <div class="carousel">
            <h2>Что думают пользователи?</h2>
            <agile>
              <div class="slide" v-for="(item, idx) in comments" :key="idx">
                <div class="card">
                  <div class="info">
                    <div class="avatar"><img :src="item.avatar" alt=""></div>
                    <div class="name">{{item.name}}</div>
                    <div class="role">{{item.role}}</div>
                    <div class="company">{{item.company}}</div>
                    <div class="address">{{item.address}}</div>
                  </div>
                  <div class="text">{{item.text}}</div>
                </div>
              </div>
              <template slot="prevButton"><img src="../assets/icons/arrow-left.svg" alt=""></template>
              <template slot="nextButton"><img src="../assets/icons/arrow-right.svg" alt=""></template>
            </agile>
          </div>
        </div>
      </div>
      <div class="white">
        <div class="container">
          <div class="partners">
            <h3>Партнеры</h3>
            <div class="list">
              <div class="item"
                   v-for="(item, idx) in partners"
                   :key="idx">
                <img :src="item.image" alt="">
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="grad">
        <div class="container">
          <div class="benefit">
            <div class="col-6 price">0 <div class="p">₽</div></div>
            <div class="col-6">
              <div class="title">С нами выгодно</div>
              <div class="text">Наша команда делает платформу Superbaer24 с мыслью о пользе, которую она принесет рынку, и с желанием увеличить интенсивность и скорость взаимодействия в оптовой торговле сегмента outdoor. Мы верим в то, что такой инструмент даст всем нам новые возможности развивать свой бизнес в эру новой неопределенности и цифровой трансформации. Именно поэтому в настоящее время как регистрация, так и использование всего базового функционала платформы абсолютно бесплатны для всех участников.
              </div>
              <div class="team">Команда Кемпинг Рус</div>
            </div>
          </div>
        </div>
      </div>
      <div class="grey">
        <div class="container">
          <div class="comfort">
            <h3>Почему с нами удобно</h3>
            <div class="top">
              <div class="col-6">
                <h4>Продавать</h4>
                <div class="item" v-for="(item, index) in sale" :key="index">
                  <div class="image"><img src="../assets/img/done.svg" alt=""></div>
                  <div class="text">{{item}}</div>
                </div>

              </div>
              <div class="col-6">
                <h4>Покупать</h4>
                <div class="item" v-for="(item, index) in buy" :key="index">
                  <div class="image"><img src="../assets/img/done.svg" alt=""></div>
                  <div class="text">{{item}}</div>
                </div>
              </div>
            </div>
            <div class="lines"></div>
            <div class="line"></div>
            <div class="col-6 oth">
              <div class="item" v-for="(item, index) in other" :key="index">
                <div class="image"><img src="../assets/img/done.svg" alt=""></div>
                <div class="text">{{item}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="white">
        <div class="container">
          <div class="community">
            <div class="item" v-for="(item, idx) in community" :key="idx">
              <div class="image"><img :src="item.avatar" alt=""></div>
              <div class="name">{{item.name}}</div>
              <div class="role">{{item.role}}</div>
              <div class="phone">{{item.phone}}</div>
              <div class="mail">{{item.mail}}</div>
            </div>
            <div class="notice">
              <div class="title">Мы на связи</div>
              <div class="text">Добрый день! Мы, Наталья и Александр, поможем вам быстро освоиться на платформе и начать использовать все ее преимущества. Напишите или позвоните нам, и мы ответим на все  ваши вопросы.</div>
            </div>
          </div>
        </div>
      </div>
      <div class="grey">
        <div class="container">
          <div class="answers">
            <h3>Ответы на популярные вопросы</h3>
            <div class="qna">
              <div class="blck col-7">
                <div class="item" v-for="(item, id) in answers" :key="id" @click="answer=item.id">
                  <div class="prev">
                    <div class="title">{{item.title}}</div>
                    <img v-if="item.id==answer" src="../assets/icons/arrow-down.svg" alt="">
                    <img v-else src="../assets/icons/arrow-right-grey.svg" alt="">
                  </div>
                  <div class="text" v-if="item.id==answer">{{item.text}}</div>
                </div>
              </div>
              <div class="image"><img src="../assets/img/questions.svg" alt=""></div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="items">
          <div class="item">
            <div class="title">Хотите попробовать?</div>
            <div class="text">Чтобы начать пользоваться всеми ресурсами Superbaer24, заполните поля формы по ссылке, и наш сотрудник свяжется с вами в ближайшее время и поможет вам освоиться на платформе</div>
            <button>Присоединиться</button>
            <div class="bottom company">(с) Superbaer24, 2021</div>
            <div class="bottom address">Россия, Москва, ул. Митинская, 16</div>
            <div class="bottom phone">+7 499 777 77 77</div>
            <div class="bottom mail">info@comfortime.ru</div>
          </div>
        </div>
      </div>
    </template>

  </main>
</template>

<script>
import { VueAgile } from 'vue-agile'

export default {
  name: "land",
  components: {agile: VueAgile},
  data: ()=>({
    isConstruction: true,
    tabs: [
      { title: 'Поставщика', role: 'provider' },
      { title: 'Закупщика', role: 'purchaser', },
    ],
    role: 'provider',
    advantages: {
      provider:   [
        {
          title: 'О вас узнают сотни магазинов',
          name: 'Продвигаем',
          text: 'О вас и вашей продукции смогут узнать сотни новых магазинов по всей России. Если вы эффективно работаете с заявками, то шансы получить новые растут'
        },
        {
          title: 'Взаимодействуйте с покупателями быстрее',
          name: 'Помогаем сотрудничать',
          text: 'Новые покупатели смогут не только узнать о вас, но и сразу оформить заказ с заключением разового договора-оферты — предоставим шаблоны. Взаимодействие с существующими покупателями станет проще и быстрее'
        },
        {
          title: 'Не думайте больше о прайс-листах',
          name: 'Экономим время',
          text: 'Вам больше не нужно будет обновлять и рассылать бесконечные прайс-листы, потому что актуальную информацию все увидят прямо на платформе. Для первичной загрузки данных достаточно нажать несколько кнопок, для последующих — одну'
        },
        {
          title: 'Работать на платформе — это спокойно',
          name: 'Ценим конфиденциальность',
          text: 'Мы видим только ту информацию, которой вы готовы поделиться: актуальные данные о товарах, открытых акциях, адресных спецпредложениях и скидках. Мы не разглашаем конфиденциальную информацию третьим лицам и другим участникам и не видим вашу статистику — все финансовые расчеты осуществляются вне платформы'
        },
      ],
      purchaser: [
          {
            title: 'Быстро находите нужные товары',
            name: 'Способствуем разнообразию ассортимента',
            text: 'Когда вы хотите торговать новой группой товаров или заказать ходовые, но их нет в наличии у ваших постоянных поставщиков — вы сможете быстро найти нужные у других поставщиков на платформе\n'
          },
          {
            title: 'Сравнивайте товары и условия сделок в едином каталоге',
            name: 'Упрощаем работу',
            text: 'Теперь вся информация от поставщиков представлена в стандартной форме в едином каталоге, вы сможете быстро и просто: искать и сравнивать товары, учитывать актуальные акции и спецпредложения, видеть актуальные остатки, загружать инструкции и сертификаты и оформлять заказ'
          },
          {
            title: 'Используйте готовые информационные материалы',
            name: 'Заботимся о маркетинге и продажах',
            text: 'Вы сможете использовать материалы платформы для продвижения и продажи онлайн и оффлайн: структуру товарного каталога, содержание карточки товаров, цифровой ценник, готовый для печати, а также рекламные материалы от поставщика\n'
          },
          {
            title: 'Спокойно работайте с новыми поставщиками',
            name: 'Гарантируем безопасность сделки',
            text: 'Мы проверяем при регистрации всех поставщиков, заключаем с ними договора и подтверждаем их надежность и помогаем разрешить конфликтные ситуации, защищая ваши интересы\n'
          },
      ]
    },
    nums: [
      {num: 20000, name: 'Товарных единиц'},
      {num: 34, name: 'Поставщиков'},
      {num: 3000, name: 'Магазинов'},
      {num: 700, name: 'Городов'},
      {num: 73, name: 'Региона'},
    ],
    partners: [
      {
        image: require("../assets/img/partner.png")
      },
      {
        image: require("../assets/img/partner1.png")
      },
      {
        image: require("../assets/img/partner.png")
      },
      {
        image: require("../assets/img/partner1.png")
      },
      {
        image: require("../assets/img/partner.png")
      },
      {
        image: require("../assets/img/partner1.png")
      },
    ],
    sale: [
        'Загрузить товары очень легко: подгрузите файл xml или нажмите кнопку синхронизации с 1С — платформа сама сформирует готовые карточки товаров, которые увидят все покупатели ',
        'Устанавливайте акции, скидки и ярлыки для своих товаров, чтобы легче продвигать их постоянным и новым покупателям',
        'Выставляйте покупателю прямо на платформе счет для оплаты'
    ],
    buy: [
        'Чтобы начать покупки, достаточно только регистрации, не надо переписываться с менеджером — ищите товары, сравнивайте, оформляйте заказ.',
        'Вы можете загрузить у нас структуру каталога, карточки товаров и ценники для организации продаж в собственном магазине.',
        'Следите за актуальным статусом заказа онлайн.',
    ],
    other: [
        'Легко ищите постоянных или новых контрагентов и добавляйте их в список избранных',
        'Оформите первый заказ по разовому договору, если с контрагентом не был заключен ранее договор, — шаблоны мы предоставим'
    ],
    community: [
      {
        avatar: require("../assets/img/community.jpg"),
        name: 'Александр Решетников',
        role: 'Менеджер по работе с клиентами',
        phone: '+7 (967) 114-80-87',
        mail: 'reshetnikov@comfortime.ru'
      },
      {
        avatar: require("../assets/img/community.jpg"),
        name: 'Наталья Спиридонова',
        role: 'Менеджер по работе с клиентами',
        phone: '+7 (967) 114-80-87',
        mail: 'spiridonova@comfortime.ru'
      }
    ],
    answers: [
      {
        id:0,
        title: 'Ваши монеты подлинные?',
        text: 'Основной способ получить бонусные баллы - это использовать определённый способ оплаты Вашего заказа. На странице оформления заказа всегда один из способов оплаты помечен зелёным блоком "Вам будет начислено N RRcoins". Алгоритм, по которому будет выбран способ оплаты, дающий бонусные баллы, регулярно изменяется, поэтому ответ на вопрос, какой способ оплаты даёт бонусные баллы, довольно быстро может устареть. Перейдя на страницу оформления заказа и дойдя до выбора способов оплаты.'
      },
      {
        id:1,
        title: 'Сколько стоит доставка до моего населённого пункта?',
        text: 'Основной способ получить бонусные баллы - это использовать определённый способ оплаты Вашего заказа. На странице оформления заказа всегда один из способов оплаты помечен зелёным блоком "Вам будет начислено N RRcoins". Алгоритм, по которому будет выбран способ оплаты, дающий бонусные баллы, регулярно изменяется, поэтому ответ на вопрос, какой способ оплаты даёт бонусные баллы, довольно быстро может устареть. Перейдя на страницу оформления заказа и дойдя до выбора способов оплаты.'
      },
      {
        id:2,
        title: 'За что начисляются бонусные баллы RRcoins?',
        text: 'Основной способ получить бонусные баллы - это использовать определённый способ оплаты Вашего заказа. На странице оформления заказа всегда один из способов оплаты помечен зелёным блоком "Вам будет начислено N RRcoins". Алгоритм, по которому будет выбран способ оплаты, дающий бонусные баллы, регулярно изменяется, поэтому ответ на вопрос, какой способ оплаты даёт бонусные баллы, довольно быстро может устареть. Перейдя на страницу оформления заказа и дойдя до выбора способов оплаты.'
      },
      {
        id:3,
        title: 'Какие варианты оплаты заказа возможны?',
        text: 'Основной способ получить бонусные баллы - это использовать определённый способ оплаты Вашего заказа. На странице оформления заказа всегда один из способов оплаты помечен зелёным блоком "Вам будет начислено N RRcoins". Алгоритм, по которому будет выбран способ оплаты, дающий бонусные баллы, регулярно изменяется, поэтому ответ на вопрос, какой способ оплаты даёт бонусные баллы, довольно быстро может устареть. Перейдя на страницу оформления заказа и дойдя до выбора способов оплаты.'
      },
      {
        id:4,
        title: 'От чего зависит цена на монету?',
        text: 'Основной способ получить бонусные баллы - это использовать определённый способ оплаты Вашего заказа. На странице оформления заказа всегда один из способов оплаты помечен зелёным блоком "Вам будет начислено N RRcoins". Алгоритм, по которому будет выбран способ оплаты, дающий бонусные баллы, регулярно изменяется, поэтому ответ на вопрос, какой способ оплаты даёт бонусные баллы, довольно быстро может устареть. Перейдя на страницу оформления заказа и дойдя до выбора способов оплаты.'
      },
    ],
    answer: 0,
    comments: [
      {
        avatar: require("../assets/img/community.jpg"),
        name: 'Наталья Спиридонова',
        role: 'Начальник отдела лодочно-закупочной станции массажного кабинета',
        company: 'Кемпинг Рус',
        address: 'Москва',
        text: 'В этом магазине покупаю парфюмерию уже более года. Очень довольна оригинальным качеством здешней продукции, вся парфюмерия, которую я покупала - аутентичная. На сайте большой выбор, мои любимые духи почти всегда в наличии. Цены, на мой взгляд, доступные, оптимальные. Доставку заказанных мной духов магазин всегда осуществлял в оговоренное время, за это время у меня ни разу не было претензий ни к покупкам, ни к доставке. Товар доставляла курьерская служба до квартиры, предварительно звонят за час до приезда. Оплачиваю всегда банковской картой по факту доставки, что тоже очень конечно удобно, пока не побывала пункты выдачи, хотя рядом с домом есть боксбери. Фото , последней покупки, мужу покупала Дольче Лайт Блю, свежий.',
      },
      {
        avatar: require("../assets/img/community.jpg"),
        name: 'Наталья Спиридонова',
        role: 'Начальник отдела лодочно-закупочной станции массажного кабинета',
        company: 'Кемпинг Рус',
        address: 'Москва',
        text: 'В этом магазине покупаю парфюмерию уже более года. Очень довольна оригинальным качеством здешней продукции, вся парфюмерия, которую я покупала - аутентичная. На сайте большой выбор, мои любимые духи почти всегда в наличии. Цены, на мой взгляд, доступные, оптимальные. Доставку заказанных мной духов магазин всегда осуществлял в оговоренное время, за это время у меня ни разу не было претензий ни к покупкам, ни к доставке. Товар доставляла курьерская служба до квартиры, предварительно звонят за час до приезда. Оплачиваю всегда банковской картой по факту доставки, что тоже очень конечно удобно, пока не побывала пункты выдачи, хотя рядом с домом есть боксбери. Фото , последней покупки, мужу покупала Дольче Лайт Блю, свежий.',
      },
      {
        avatar: require("../assets/img/community.jpg"),
        name: 'Наталья Спиридонова',
        role: 'Начальник отдела лодочно-закупочной станции массажного кабинета',
        company: 'Кемпинг Рус',
        address: 'Москва',
        text: 'В этом магазине покупаю парфюмерию уже более года. Очень довольна оригинальным качеством здешней продукции, вся парфюмерия, которую я покупала - аутентичная. На сайте большой выбор, мои любимые духи почти всегда в наличии. Цены, на мой взгляд, доступные, оптимальные. Доставку заказанных мной духов магазин всегда осуществлял в оговоренное время, за это время у меня ни разу не было претензий ни к покупкам, ни к доставке. Товар доставляла курьерская служба до квартиры, предварительно звонят за час до приезда. Оплачиваю всегда банковской картой по факту доставки, что тоже очень конечно удобно, пока не побывала пункты выдачи, хотя рядом с домом есть боксбери. Фото , последней покупки, мужу покупала Дольче Лайт Блю, свежий.',
      },
      {
        avatar: require("../assets/img/community.jpg"),
        name: 'Наталья Спиридонова',
        role: 'Начальник отдела лодочно-закупочной станции массажного кабинета',
        company: 'Кемпинг Рус',
        address: 'Москва',
        text: 'В этом магазине покупаю парфюмерию уже более года. Очень довольна оригинальным качеством здешней продукции, вся парфюмерия, которую я покупала - аутентичная. На сайте большой выбор, мои любимые духи почти всегда в наличии. Цены, на мой взгляд, доступные, оптимальные. Доставку заказанных мной духов магазин всегда осуществлял в оговоренное время, за это время у меня ни разу не было претензий ни к покупкам, ни к доставке. Товар доставляла курьерская служба до квартиры, предварительно звонят за час до приезда. Оплачиваю всегда банковской картой по факту доставки, что тоже очень конечно удобно, пока не побывала пункты выдачи, хотя рядом с домом есть боксбери. Фото , последней покупки, мужу покупала Дольче Лайт Блю, свежий.',
      },
      {
        avatar: require("../assets/img/community.jpg"),
        name: 'Наталья Спиридонова',
        role: 'Начальник отдела лодочно-закупочной станции массажного кабинета',
        company: 'Кемпинг Рус',
        address: 'Москва',
        text: 'В этом магазине покупаю парфюмерию уже более года. Очень довольна оригинальным качеством здешней продукции, вся парфюмерия, которую я покупала - аутентичная. На сайте большой выбор, мои любимые духи почти всегда в наличии. Цены, на мой взгляд, доступные, оптимальные. Доставку заказанных мной духов магазин всегда осуществлял в оговоренное время, за это время у меня ни разу не было претензий ни к покупкам, ни к доставке. Товар доставляла курьерская служба до квартиры, предварительно звонят за час до приезда. Оплачиваю всегда банковской картой по факту доставки, что тоже очень конечно удобно, пока не побывала пункты выдачи, хотя рядом с домом есть боксбери. Фото , последней покупки, мужу покупала Дольче Лайт Блю, свежий.',
      },
    ]
  }),
  computed:{
    isConstruction(){
      return process.env.VUE_APP_CONSTRUCTION === 'true'
    },
    getAdvantages(){
      return this.advantages[this.role]
    }
  },
}
</script>

<style lang="scss">
.crd {
  transition: all 0.5s;
  display: inline-block;
}
.list-complete-enter, .list-complete-leave-to{
  opacity: 0;
  transform: translateX(30px);
}
.list-complete-leave-active {
  position: absolute;
}
.grey{
  background: #F9F9FB;
}
.white{
  background: #ffffff;
}
.mask{
  height: 750px;
  background: url("../assets/img/mask-bg.png") center no-repeat;
  .bg{
    width: 100%;
    height: 100%;
    background: rgba(58, 119, 97, 0.6);

  }
}
.grad{
  background: linear-gradient(280.89deg, #29A377 5.33%, #30CA92 95.43%);
}
.footer{
  position: relative;
  height: 640px;
  background-color: #F9F9FB;
  background-image: url("../assets/img/footer.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
  .items{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    .item{
      .title{
        font-family: Montserrat;
        font-style: normal;
        font-weight: bold;
        font-size: 36px;
        line-height: 44px;
        text-align: center;
        letter-spacing: 0.02em;
        color: #FFFFFF;
        margin-bottom: 30px;
      }
      .text{
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        color: #FFFFFF;
        max-width: 550px;
      }
      button{
        border: none;
        outline: none;
        margin: 50px auto;
        background: #2CB181;
        border-radius: 4px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #FFFFFF;
        height: 40px;
        padding: 0 65px;
      }
      .bottom{
        font-family: Montserrat;
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        color: #EEF0F3;
        &.company{
          margin-top: 150px;
        }
        &.mail{
          margin-bottom: 50px;
        }
      }
    }
  }
}

.text{
  margin-top: 20px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 44px;
  color: #2CB181;
}

h1{
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 50px;
  line-height: 61px;
  color: #2CB181;
}
h2{
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 44px;
  letter-spacing: 0.02em;
  color: #2D3137;
}
h4{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #7A818F;
  margin-bottom: 20px;
}

 .container{
   .auth-links{
      display: flex;
     align-items: center;
     justify-content: flex-end;
     width: 100%;
     padding-top: 20px;
     button{
       font-family: Montserrat;
       font-style: normal;
       font-weight: 600;
       font-size: 14px;
       line-height: 17px;
       color: #FFFFFF;
       height: 40px;
       padding: 0 25px;
       background: #2CB181;
       border-radius: 4px;
       border: none;
       &.login{
          background: transparent;
         border: 1px solid #B6BCC8;
         color: #7A818F;
         margin-right: 10px;
       }
     }
   }
   .logo{
     margin-top: 60px;
     margin-bottom: 40px;
   }
   .frst{
     padding-bottom: 220px;
   }
   .description{
     padding: 150px 0;
      display: flex;
     align-items: flex-start;
     justify-content: space-between;
     .text{
       font-family: Montserrat;
       font-style: normal;
       font-weight: 600;
       .title{
         font-size: 20px;
         line-height: 24px;
         letter-spacing: 0.02em;
         color: #7A818F;
         margin-bottom: 14px;
       }
       .about{
         font-size: 26px;
         line-height: 32px;
         color: #2D3137;
         margin-bottom: 18px;
       }
       .bottom{
         font-weight: 500;
         font-size: 16px;
         line-height: 20px;
         color: #7A818F;
       }
     }
     .image{
       background: url("../assets/img/screen.png");
       filter: drop-shadow(0px 0px 30px rgba(129, 129, 129, 0.25));
       border-radius: 10px;
       margin-left: 50px;
       height: 350px;
       background-size: cover;
       img{


       }
     }
   }
   .advantages{
     background: url("../assets/img/line.svg") no-repeat;
     background-size: contain;
     margin-top: 120px;
     height: 770px;
     margin-bottom: 150px;
     position: relative;
     .rad{
       position: absolute;
       top: 200px;
       left: 350px;
       .radio{
         font-family: Montserrat;
         font-style: normal;
         font-weight: 600;
         font-size: 30px;
         line-height: 37px;
         letter-spacing: 0.02em;
         color: #2D3137;
         width: max-content;
         background-color: white;
         border-radius: 4px;
         border: 1px solid #EEF0F3;

         &-item {
           cursor: pointer;
           padding: 25px 70px;
           margin: 2px;
           text-align: center;
           color: #7A818F;
         }
         &-item.active {
           color: #2D3137;
           background: #EEF0F3;
           border-radius: 4px;
         }
       }

     }
     .crd{
       position: absolute;
       width: 280px;
       background: #FFFFFF;
       box-shadow: 0px 0px 3px #E5E5EA;
       border-radius: 10px;
       padding: 20px;
       font-family: Montserrat;
       font-style: normal;
       font-weight: 600;
       &_0{
         top: 20px;
         right: -30px;
       }
       &_1{
         top: 550px;
         right: 10px;
       }
       &_2{
         top: 570px;
         right: 560px;
       }
       &_3{
         top: 310px;
         left: -80px;
       }
       .num{
         position: absolute;
         top: 5px;
         right: 8px;
         font-weight: 500;
         font-size: 18px;
         line-height: 22px;
         color: #7A818F;
       }
       .title{
         font-size: 18px;
         line-height: 22px;
         color: #2CB181;
         padding-bottom: 15px;
         border-bottom: 1px solid #EEF0F3;
       }
       .name{
         font-size: 14px;
         line-height: 17px;
         color: #2D3137;
         margin-top: 15px;
         margin-bottom: 10px;
       }
       .text{
         font-weight: 500;
         font-size: 13px;
         line-height: 16px;
         color: #7A818F;
       }
     }
   }
   .reg{
     padding-top: 100px;
     .map{
       height: 650px;
       background: url("../assets/img/map.png") no-repeat;
       background-size: contain;
     }
     .numbers{
       display: flex;
       align-items: center;
       padding-bottom: 130px;
       .item{
         margin-right: 70px;
         font-family: Montserrat;
         font-style: normal;
         letter-spacing: 0.02em;
         .num{
           font-weight: 600;
           font-size: 50px;
           line-height: 61px;
           color: #2CB181;
         }
         .name{
           font-weight: 500;
           font-size: 18px;
           line-height: 22px;
           color: #2D3137;
         }
       }
     }
   }
   .wrp{
     display: flex;
     padding-top: 200px;
     .col-4{
       padding: 0;
     }
      .blr{
        display: flex;
        .blur{
          margin-right: 3px;
          margin-bottom: 3px;
          padding: 36px 25px;
          background: rgba(60, 112, 88, 0.65);
          backdrop-filter: blur(20px);
          border-radius: 10px;
          font-family: Montserrat;
          font-style: normal;
          .title{
            margin-bottom: 5px;
            font-weight: 600;
            font-size: 16px;
            line-height: 22px;
            color: #F9F9FB;
          }
          .text{
            font-weight: 500;
            font-size: 12px;
            line-height: 16px;
            color: #EEF0F3;
          }
        }
      }
   }
   .carousel{
     padding: 100px 0;
     position: relative;
     h2{
       margin-left: 25px;
       margin-bottom: 25px;
     }
     .agile {
       width: 100%;
     }
     .agile__actions {
       margin-top: 20px;
     }
     .agile__nav-button {
       z-index: 5;
       margin-top: -350px;
       background: transparent;
       border: none;
       color: #ccc;
       cursor: pointer;
       -webkit-transition-duration: 0.3s;
       transition-duration: 0.3s;
     }
     .agile__nav-button:hover {
       color: #888;
     }
     .agile__dot {
       margin: 0 5px;
     }
     .agile__dot button {
       background-color: #D5D9E0;
       border: none;
       border-radius: 50%;
       cursor: pointer;
       display: block;
       height: 10px;
       font-size: 0;
       line-height: 0;
       margin: 0;
       padding: 0;
       -webkit-transition-duration: 0.3s;
       transition-duration: 0.3s;
       width: 10px;
     }
     .agile__dot:hover button{
       background-color: #9cbaaf;
     }
     .agile__dot--current button {
       background-color: #2CB181;
     }

     .slide {
       -webkit-box-align: center;
       align-items: center;
       color: #000000;
       padding: 0 25px;
       display: -webkit-box;
       display: flex;
       height: 300px;
       -webkit-box-pack: center;
       justify-content: center;
       .card{
         height: 100%;
         width: 100%;
         background: #FFFFFF;
         box-shadow: 0px 0px 3px #E5E5EA;
         border-radius:10px;
         padding: 20px;
         display: flex;
         flex-direction: row;
         .info{
           width: 150px;
           margin-right: 25px;
           font-family: Montserrat;
           font-style: normal;
           font-weight: 600;
           letter-spacing: 0.02em;
           .avatar{
             overflow: hidden;
             border-radius: 50%;
             height: 125px;
             width: 125px;
             margin-bottom: 10px;
             img{
               width: 100%;
             }
           }
           .name{
             font-size: 16px;
             line-height: 20px;
             color: #2D3137;
           }
           .role{
             font-size: 12px;
             line-height: 15px;
             color: #7A818F;
           }
           .company{
             font-size: 12px;
             line-height: 15px;
             color: #2CB181;
           }
           .address{
             font-size: 12px;
             line-height: 15px;
             color: #7A818F;
             font-weight: 500;
           }
         }
         .text{
           font-family: Montserrat;
           font-style: normal;
           font-weight: 500;
           font-size: 17px;
           line-height: 156.4%;
           color: #2D3137;
           width: calc(100% - 175px);
         }
       }
     }
   }
   .partners{
     padding-top: 100px;
     padding-bottom: 150px;
     .list{
       display: flex;
       align-items: center;
       .item{
         height: 110px;
         width: 170px;
         display: flex;
         align-items: center;
         justify-content: center;
         background: #FFFFFF;
         box-shadow: 0px 0px 3px #E5E5EA;
         border-radius: 10px;
         margin-right: 5px;
         img{
           max-width: 150px;

         }
       }
     }
   }
   .benefit{
     padding: 200px 0;
     display: flex;
     font-family: Montserrat;
     font-style: normal;
     color: #FFFFFF;
     .price{
       display: flex;
       font-weight: bold;
       font-size: 350px;
       line-height: 410px;
       .p{
         color: transparent;
         -webkit-text-stroke: 2px #FFFFFF;
       }
     }
     .title{
       font-weight: bold;
       font-size: 36px;
       line-height: 44px;
       letter-spacing: 0.02em;
       margin-bottom: 20px;
     }
     .text{
       font-weight: 500;
       font-size: 18px;
       line-height: 26px;
       margin-bottom: 15px;
     }
     .team{
       font-weight: 600;
       font-size: 14px;
       line-height: 17px;
       color: #A9ECD0;
     }
   }
   .comfort{
     padding: 150px 0;

     .top{
       display: flex;
       margin-top: 40px;
     }
     .lines{
       height: 50px;
       border: 2px solid #D5D9E0;
       border-top: none;
     }
     .line{
       height: 50px;
       border-right: 2px solid #D5D9E0;
       width: 50%;
     }
     .oth{
       margin-left: 30%;
     }
     .item{
       display: flex;
       margin-bottom: 20px;
       .image{
         margin-top: 5px;
         margin-right: 20px;
       }
       .text{
         padding-right: 50px;
         font-family: Montserrat;
         font-style: normal;
         font-weight: 500;
         font-size: 18px;
         line-height: 22px;
         color: #2D3137;
       }
     }
   }
   .community{
     padding: 150px 0;
     display: flex;
      .item{
        margin-right: 20px;
        text-align: center;
        padding: 100px 30px 30px 30px;
        background: #F9F9FB;
        border-radius: 10px;
        height: 240px;
        width: 300px;
        position: relative;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        letter-spacing: 0.02em;
        .image{
          overflow: hidden;
          position: absolute;
          border-radius: 50%;
          height: 150px;
          width: 150px;
          top: -75px;
          left: calc(50% - 75px);
          img{
            width: 100%;
          }
        }
        .name{

          font-size: 16px;
          line-height: 20px;
          text-align: center;
          color: #000000;
        }
        .role{

          font-size: 13px;
          line-height: 16px;
          text-align: center;
          color: #7A818F;
        }
        .phone{
          margin-top: 15px;
          font-size: 16px;
          line-height: 20px;
          text-align: center;
          color: #2CB181;
        }
        .mail{

          font-size: 13px;
          line-height: 16px;
          text-align: center;
          color: #2D3137;
        }
      }
     .notice{
       max-width: 450px;
       margin-left: 50px;
       font-family: Montserrat;
       font-style: normal;
       letter-spacing: 0.02em;
       color: #2D3137;
       margin-top: 10px;
       .title{
         font-weight: bold;
         font-size: 36px;
         line-height: 44px;
         margin-bottom: 15px;
       }
       .text{
         font-weight: 500;
         font-size: 18px;
         line-height: 22px;
       }
     }
   }
   .answers{
     padding: 150px 0;
     .qna{
       display: flex;
       align-items: center;
       .blck{
         .item{
           background: #FFFFFF;
           box-shadow: 0px 1px 4px rgba(95, 95, 95, 0.25);
           border-radius: 12px;
           padding: 20px;
           margin-bottom: 3px;
           font-family: Montserrat;
           font-style: normal;
           font-weight: 500;
           cursor: pointer;
           .prev{
             display: flex;
             align-items: center;
             justify-content: space-between;
           }
           .title{
             font-size: 18px;
             line-height: 22px;
             color: #282625;
           }
           .text{
             margin-top: 15px;
             font-size: 14px;
             line-height: 139.9%;
             color: #2D3137;
           }
         }
       }
       .image{
         margin-left: 50px;
       }
     }

   }
 }
</style>
